/* button */
/*--------------------------------------------------------------------------------*/
export const loading = (
    btn: HTMLButtonElement,
    state = false,
) => {
    if (state) {
        btn.querySelector<HTMLElement>('.btn-loader')?.remove();
        btn.style.color = 'transparent';
        btn.style.position = 'relative';
        btn.style.pointerEvents = 'none';
        const loader = document.createElement('div');
        loader.className = 'btn-loader';
        loader.innerHTML = `<div class="spinner s22"></div>`;
        btn.appendChild(loader);
    } else {
        btn.querySelector<HTMLElement>('.btn-loader')?.remove();
        btn.style.color = '';
        btn.style.position = '';
        btn.style.pointerEvents = '';
    }
};
/*--------------------------------------------------------------------------------*/
